/* eslint-disable no-use-before-define */
/* eslint-disable no-useless-concat */
import React, { useState, useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../App.css';
import { Paper, Typography, Button } from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import Sidebar from '../components/Sidebar';
import { Navbar } from '../components';
import { variables } from '../components/Variables';
import TrendsEbayGraph from './TrendsEbayGraph';

const TrendsEbay = () => {
  const defaultStartDate = new Date(
    new Date(new Date().getTime()).setDate(new Date().getDate() - 31),
  );
  const defaultEndDate = new Date(
    new Date(new Date().getTime()).setDate(new Date().getDate() - 1),
  );
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);
  const [ebayGraph, setEbayGraph] = useState([]);

  const userInfo = !!localStorage.getItem('loginID')
    && JSON.parse(localStorage.getItem('loginID'));
  const { activeMenu } = useStateContext();
  const navigate = useNavigate();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      if (localStorage.getItem('loginID')) {
        getCertifiedTrends();
      }
    }
  }, []);
  useEffect(() => {
    if (startDate === null) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please Select Date!',
      });
      setStartDate(new Date());
    }
  }, [startDate]);

  const getCertifiedTrends = async () => {
    setLoading(true);
    try {
      const data = {
        UserId: userInfo.UserId,
        ProcessName: variables.PROCESSNAME,
        PageName: 'Ebay Trends',
        FromDate: startDate,
        ToDate: endDate,
      };

      const response = await axios.post(
        `${variables.BASE_URL}EbayTrends`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );
      const Data = response.data;
      if (Data.IsSuccess && Data.IsAuthorize) {
        // setGraphData(Data.ReceivingTrend);
        setEbayGraph(Data.EbayTrends);
      } else if (!Data.IsAuthorize) {
        setEbayGraph([]);
        setTimeout(() => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Access Denied!',
          });
          navigate('/');
        }, 0);
      } else {
        setEbayGraph([]);
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: Data.Reason,
        });
      }
    } catch (error) {
      setEbayGraph([]);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error,
      });
    }
    setLoading(false);
  };

  // BELOW CODE FOR DATE SELECTION START TO END******
  const handleEndDateChange = (date) => {
    setEndDate(date);
    if (date) {
      const calculatedFromDate = new Date(date);
      calculatedFromDate.setDate(calculatedFromDate.getDate() - 30);
      setStartDate(calculatedFromDate);
    } else {
      setStartDate(null);
    }
  };
  const disableFutureDates = (date) => date.getTime() < new Date().getTime();

  return (
    <div className="flex relative dark:bg-main-dark-bg">
      {activeMenu ? (
        <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
          <Sidebar />
        </div>
      ) : (
        <div className="w-0 dark:bg-secondary-dark-bg">
          <Sidebar />
        </div>
      )}

      <div
        style={{
          width: `${activeMenu ? '100%' : '100%'} `,
          paddingLeft: `${activeMenu ? '300px' : '0px'}`,
        }}
      >
        <div
          className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full "
          id="navMenu_id"
          style={{
            background: 'linear-gradient(to right, #060047 , #00FFFF  )',
            borderRadius: '10px',
          }}
        >
          <Navbar />
          <div
            className="container-fluid d-flex justify-content-center align-items-center py-3"
            style={{ marginBottom: '-100px' }}
          >
            <Typography
              variant="h6"
              sx={{
                padding: '0px',
                margin: '0px 0px -20px 0px',
                color: 'black',
              }}
            >
              Analysis of last 30 days data.
            </Typography>
          </div>
          <div
            className="container-fluid d-none justify-content-center align-items-center py-3"
            id="commondatePicker_id"
            style={{ marginBottom: '-100px' }}
          >
            <div
              className="row justify-content-center align-items-center gx-2"
              style={{ padding: '5px', marginTop: '-60px' }}
              id="datePicker_id2"
            >
              <div className="col-12 col-md-1 d-flex align-items-center mb-2 mb-md-0">
                <Typography variant="h6">From</Typography>
              </div>
              <div className="col-12 col-md-3 mb-2 mb-md-0">
                <DatePicker
                  disabled
                  className="form-control"
                  dateFormat="yyyy-MM-dd"
                  selected={startDate}
                />
              </div>
              <div className="col-12 col-md-1 d-flex align-items-center mb-2 mb-md-0">
                <Typography variant="h6">To</Typography>
              </div>
              <div className="col-12 col-md-3 mb-2 mb-md-0">
                {loading ? (
                  <DatePicker
                    disabled
                    className="form-control"
                    dateFormat="yyyy-MM-dd"
                    selected={endDate}
                  />
                ) : (
                  <DatePicker
                    className="form-control"
                    dateFormat="yyyy-MM-dd"
                    selected={endDate}
                    onChange={handleEndDateChange}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="End date"
                    autoComplete="off"
                    filterDate={disableFutureDates}
                    minDate={new Date(2022, 1)}
                    excludeDates={[new Date()]}
                  />
                )}
              </div>
              <Button
                onClick={getCertifiedTrends}
                variant="contained"
                size="medium"
                className="col-xs-6 col-sm-4 col-md-2 col-lg-2"
              >
                Search
              </Button>
            </div>
          </div>
        </div>
        <div>
          <div className="container-fluid">
            <div id="table_container">
              <Paper className="graph_paper">
                <TrendsEbayGraph
                  ebayGraph={ebayGraph}
                  loading={loading}
                  setLoading={setLoading}
                />
              </Paper>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrendsEbay;
